import { useEffect, useState } from "react";
import { Button, Form, Input, message } from "antd";
import { useTranslation } from "react-i18next";
import { useManagementStore } from "@/stores/management";
import { orgService } from "@/services/organization";


export function OrgSettings() {
  const { t } = useTranslation("management");
  const { context, setContext } = useManagementStore();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const orgId = context?.type === "org" ? context.org.id : "";

  useEffect(() => {
    if (context?.type === "org") {
      form.setFieldsValue({ name: context.org.name, plan: context.org.plan || "" });
    }
  }, [context, form]);

  const handleSave = async (values: { name: string; plan: string }) => {
    if (!orgId) return;
    setLoading(true);
    try {
      const updated = await orgService.update(orgId, {
        name: values.name,
        plan: values.plan || undefined,
      });
      setContext({ type: "org", org: updated });
      message.success(t("common:success"));
    } catch {
      message.error(t("common:error"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Form form={form} layout="vertical" onFinish={handleSave} style={{ maxWidth: 480 }}>
        <Form.Item label={t("settings.name")} name="name" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item label={t("settings.plan")} name="plan">
          <Input />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading}>{t("common:save")}</Button>
        </Form.Item>
      </Form>
    </>
  );
}
